import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularCall: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_call"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="call icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M7.05646 2.41844L8.22346 2.06668C9.54596 1.66804 10.959 2.31227 11.5253 3.5721L12.427 5.57782C12.9097 6.65165 12.6553 7.91366 11.7943 8.71661L10.3 10.1101C10.2563 10.1508 10.2286 10.2058 10.222 10.2652C10.1777 10.6623 10.4469 11.4357 11.0671 12.51C11.5182 13.2913 11.9264 13.8391 12.2739 14.1473C12.516 14.362 12.6493 14.4084 12.7061 14.3915L14.7164 13.7769C15.842 13.4328 17.0618 13.8431 17.7505 14.7976L19.0312 16.5726C19.8373 17.6898 19.6924 19.2311 18.6921 20.1784L17.8057 21.0178C16.8493 21.9236 15.4877 22.2611 14.219 21.907C11.4649 21.1383 8.99559 18.8141 6.78372 14.9831C4.56877 11.1467 3.79158 7.84222 4.50803 5.07043C4.8359 3.80195 5.80203 2.79656 7.05646 2.41844ZM7.48936 3.85461C6.7367 4.08148 6.15702 4.68472 5.9603 5.44581C5.35765 7.77732 6.04651 10.7062 8.08276 14.2331C10.1163 17.7552 12.3052 19.8155 14.6223 20.4622C15.3835 20.6747 16.2004 20.4722 16.7743 19.9287L17.6606 19.0893C18.1153 18.6587 18.1812 17.9581 17.8148 17.4503L16.5341 15.6753C16.221 15.2415 15.6666 15.0549 15.1549 15.2114L13.1396 15.8275C11.9699 16.1762 10.9082 15.2347 9.76811 13.26C8.9998 11.9293 8.64171 10.9006 8.73128 10.0987C8.77768 9.68322 8.97125 9.29812 9.27697 9.01303L10.7713 7.61958C11.1627 7.2546 11.2783 6.68096 11.0589 6.19286L10.1572 4.18714C9.89977 3.61449 9.25749 3.32165 8.65636 3.50285L7.48936 3.85461Z" />
      </svg>
    </span>
  );
};

export { RegularCall };
